import { Box, Stack, styled } from '@mui/material'

import { COLORS, LinkUnstyled, serratedEdgeHorizontalCss, remUnit, unit } from '@hcr/ui'

export const LayoutTicketDetailsActiveContainer = styled(Box)`
  padding: 0 ${unit(3)} ${unit(3)};
`

export const LayoutTicketDetailsActiveContent = styled(Stack)`
  background-color: ${COLORS.white};

  ${serratedEdgeHorizontalCss}
`

export const LayoutTicketDetailsActiveHeader = styled(Box)`
  position: relative;
  background-color: ${COLORS.burgundi[500]};
  padding: ${unit(4)} ${unit(4)} 0;
`

export const LayoutTicketDetailsActiveHeaderContent = styled(Stack)`
  justify-content: center;
  align-items: center;
  text-align: center;
  height: ${unit(55)};
  border: ${unit(0.5)} dashed ${COLORS.burgundi.tint};
`

export const LayoutTicketDetailsActiveArrowLinkIcon = styled(LinkUnstyled)`
  color: ${COLORS.white};
  position: absolute;
  top: ${unit(10)};
  left: ${unit(10)};
  font-size: ${remUnit(6)};
`

export const LayoutTicketDetailsActiveInfo = styled(Box)`
  padding: 0 ${unit(4)};
`

export const LayoutTicketDetailsActiveInfoContent = styled(Stack)`
  align-items: stretch;
  gap: ${unit(7)};
  position: relative;
  transform: translateY(${unit(-7.5)});
  background-color: white;
  padding-top: ${unit(6)};
`

export const LayoutTicketDetailsActiveName = styled(Box)`
  display: flex;
  justify-content: center;
  padding-bottom: ${unit(6)};
  border-bottom: ${unit(0.5)} dashed ${COLORS.hiekka[500]};
`

export const LayoutTicketDetailsActiveInfoContentSection = styled(Stack)`
  justify-content: center;
  align-items: center;
`

export const LayoutTicketDetailsActiveFooter = styled(Stack)`
  gap: ${unit(5)};
  padding: ${unit(5)} ${unit(4)};
`
